<template>
  <AssessmentForm @submit.prevent="onSubmit">
    <template slot="header">{{ header }}</template>
    <template slot="description">
      <p>
        Each question is completely optional and you can skip any step.
      </p>
    </template>
    <div class="field-container">
      <RadioInput :options="options" :value="status" @change="onChange" />
    </div>
  </AssessmentForm>
</template>

<script>
import AssessmentForm from '@/components/assessment-form';
import RadioInput from '@/components/radio-input';
import { mapGetters } from 'vuex';
import { StoreGetters, saveState } from '@/store';

export default {
  components: { AssessmentForm, RadioInput },
  data() {
    return {
      isLoading: false,
      status: this.$store.state.state || 0,
    };
  },
  computed: {
    ...mapGetters({ name: StoreGetters.GET_USER_NAME }),
    header() {
      let result = this.name ? `${this.name}, are` : 'Are';
      result += ' you experiencing COVID-19 symptoms?';
      return result;
    },
    options() {
      return [
        'None',
        'Mild Symptoms',
        'Moderate Symptoms',
        'Critical Care Needed',
      ];
    },
  },
  methods: {
    onChange(val) {
      this.status = parseInt(val, 10);
    },
    async onSubmit() {
      if (this.isLoading) return;
      this.isLoading = true;
      await saveState(this.status);
      this.isLoading = false;
      this.$emit('submit');
    },
  },
};
</script>

<style lang="scss" scoped></style>
